import type { FC } from "react"

import { ClipboardCopyIcon, ReloadIcon } from "@radix-ui/react-icons"

import {
	type FragmentType,
	getFragmentData,
	graphql,
} from "@/souhl_admin/gql/__generated__"

import styles from "../../DatasourceConfigTable.module.scss"

const connectionStatusCellFragment = graphql(/* GraphQL */ `
	fragment ConnectionStatusCell on DataSourceConnectionStatus {
		dataSourceStoreName
		hasIdPassError
		loginId
		storeId
	}
`)

type ConnectionStatusCellProps = {
	status: FragmentType<typeof connectionStatusCellFragment> | null
	dataSourceLabel: string
	copying: boolean
	onCopyPassword: () => Promise<void>
}

const ConnectionStatusCell: FC<ConnectionStatusCellProps> = ({
	status: statusFragment,
	dataSourceLabel,
	copying,
	onCopyPassword,
}) => {
	if (!statusFragment) {
		return <span className={styles.noConnection}>--</span>
	}

	const status = getFragmentData(connectionStatusCellFragment, statusFragment)

	const copyButton = (
		<button
			type="button"
			className={styles.passwordCopyButton}
			onClick={(event) => {
				event.stopPropagation()
				void onCopyPassword()
			}}
			disabled={copying}
			title="パスワードをクリップボードにコピー"
			aria-label={`${dataSourceLabel} のパスワードをコピー`}
		>
			{copying ? (
				<ReloadIcon className={styles.passwordCopySpinner} />
			) : (
				<ClipboardCopyIcon />
			)}
		</button>
	)

	if (status.hasIdPassError) {
		return (
			<div className={styles.connectionCellContent}>
				<span className={styles.errorBadge}>id pass エラー</span>
				{copyButton}
			</div>
		)
	}

	return (
		<div className={styles.connectionCellContent}>
			<div className={styles.connectionInfo}>
				<span className={styles.connectionName}>
					{status.dataSourceStoreName}
				</span>
				{(status.loginId || status.storeId) && (
					<span className={styles.connectionMeta}>
						({status.loginId}
						{status.storeId ? ` / ${status.storeId}` : ""})
					</span>
				)}
			</div>
			{copyButton}
		</div>
	)
}

export default ConnectionStatusCell
